// extracted by mini-css-extract-plugin
export default {"actorsInfo":"Actor_actorsInfo__PRsv9","image":"Actor_image__58FNt","content":"Actor_content__lAOmV","buttons":"Actor_buttons__wJjEK"};